/* Copyright 2019 The MathWorks, Inc. */

define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {

        editOption: false,
        editOptionMessage: "",
        hasDynamicEdit: false,

        /**
         * If set to true, the editOption property adds a context menu entry to edit the widget.
         * @param value
         * @private
         */
        _setEditOptionAttr: function (value) {
            if (typeof value !== "boolean") {
                throw new Error("'editOption' property expected a boolean value.");
            }
            this._set("editOption", value);
        },

        /**
         * editOptionMessage property allows users to specify the message displayed for the
         * 'edit' action in context menu
         * @param value
         * @private
         */
        _setEditOptionMessageAttr: function (value) {
            if (typeof value !== "string") {
                throw new Error("'editOptionMessage' property expected a string value.");
            }
            this._set("editOptionMessage", value);
        },

        _setHasDynamicEditAttr: function (value) {
            this._set("hasDynamicEdit", value);
        },

        /**
         * Emits 'edit' event when the editing context menu option is selected by user.
         * UI author can then respond accordingly.
         * @private
         */
        _emitEditEvent: function () {
            this.emit("edit");
        }
    });
});